import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  AppBar,
  Toolbar,
  InputAdornment,
  CircularProgress,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';

// --Alerta --- NO remplase el el modal por el nuevo componente Modal raza esta pendiente de sustituir el Dialog de aqui  --Alerta ---
 
const Razas = () => {
  const [razas, setRazas] = useState([]);
  const [originalRazas, setOriginalRazas] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRaza, setSelectedRaza] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    id_pet: '',
    id_especie: '',
    nombre_raza: '',
    habilitada: true,
  });
  const [especies, setEspecies] = useState([]);
  const [pets, setPets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userIdPet, setUserIdPet] = useState(null);
  const [userIdRol, setUserIdRol] = useState(null);
  const [userSucursales, setUserSucursales] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();

  // Decodificar token JWT para obtener id_pet, id_rol y sucursales
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        console.log('Payload del token:', payload);
        setUserIdPet(payload.id_pet || null);
        setUserIdRol(payload.id_rol || null);
        setUserSucursales(payload.sucursales || []);
      } catch (err) {
        console.error('Error al decodificar el token:', err);
        const errorMsg = 'Error al decodificar el token de usuario';
        setError(errorMsg);
        setSnackbarMessage(errorMsg);
        setSnackbarOpen(true);
      }
    } else {
      const errorMsg = 'No se encontró un token de usuario';
      setError(errorMsg);
      setSnackbarMessage(errorMsg);
      setSnackbarOpen(true);
    }
  }, []);

  // Formatear fechas
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // Normalizar datos de raza
          const normalizeRaza = (raza) => {
            if (!raza || !raza.id_raza) {
              console.warn('Raza inválida recibida:', raza);
              return null;
            }
            
            // SOLUCIÓN: Usar Boolean(value) para manejar cualquier valor de la DB (0, 1, true, false)
            // Si la DB envía 1 o true, será true. Si envía 0 o false, será false.
            const habilitadaValue = Boolean(raza.habilitada); 

            return {
              id_raza: raza.id_raza ?? null,
              id_pet: raza.id_pet ?? null,
              id_especie: raza.id_especie ?? null,
              nombre_raza: raza.nombre_raza ?? '',
              // Aplicamos el valor booleano normalizado
              habilitada: habilitadaValue,
              createdAt: raza.createdAt ?? null,
              updatedAt: raza.updatedAt ?? null,
            };
            
              };

  // Obtener razas, especies y pets
  useEffect(() => {
    const fetchData = async () => {
      if (!userIdPet || !userIdRol) {
        console.log('Esperando id_pet o id_rol del usuario...');
        return;
      }
      try {
        setLoading(true);
        const razasRes = await api.get('/razas/');
        console.log('Datos crudos de GET /razas:', razasRes.data);
        const razasData = Array.isArray(razasRes.data)
          ? razasRes.data.filter(item => item !== null && item !== undefined)
          : [];
        const allowedPets = [userIdPet, ...userSucursales];
        const normalizedRazas = razasData
          .map(normalizeRaza)
          .filter(raza => raza !== null && raza.id_raza && allowedPets.includes(raza.id_pet));
        console.log('Razas normalizadas:', normalizedRazas);
        setRazas(normalizedRazas);
        setOriginalRazas(normalizedRazas);

        const especiesRes = await api.get('/especies/');
        console.log('Respuesta de especies:', especiesRes.data);
        setEspecies(Array.isArray(especiesRes.data) 
          ? especiesRes.data.filter(especie => allowedPets.includes(especie.id_pet) && especie.habilitada === true) 
          : []);

        const petsRes = await api.get('/pets/');
        console.log('Respuesta de pets:', petsRes.data);
        setPets(Array.isArray(petsRes.data) ? petsRes.data.filter(pet => allowedPets.includes(pet.id_pet)) : []);
        setLoading(false);
      } catch (error) {
        console.error('Error al cargar datos:', error);
        const errorMsg = 'Error al cargar datos: ' + (error.response?.data?.detail || error.message || JSON.stringify(error));
        setError(errorMsg);
        setSnackbarMessage(errorMsg);
        setSnackbarOpen(true);
        setLoading(false);
      }
    };
    fetchData();
  }, [userIdPet, userIdRol, userSucursales]);

  // Buscar razas en frontend
  useEffect(() => {
    const searchRazas = () => {
      // Al limpiar o borrar el término de búsqueda, se restauran las razas originales
      if (!searchTerm || searchTerm.trim() === '') {
        setRazas(originalRazas);
        setPage(0);
        return;
      }
      
      const filteredRazas = originalRazas
        .filter(raza => raza && raza.id_raza && raza.nombre_raza)
        .filter(raza => raza.nombre_raza.toLowerCase().includes(searchTerm.toLowerCase().trim()));
        
      setRazas(filteredRazas);
      setPage(0);
    };
    searchRazas();
  }, [searchTerm, originalRazas]);

  // Abrir modal para crear/editar raza
  const handleOpenModal = (raza = null) => {
    setSelectedRaza(raza);
    setFormData(
      raza
        ? normalizeRaza(raza) || {
            id_pet: userIdPet || '',
            id_especie: '',
            nombre_raza: '',
            habilitada: true,
          }
        : {
            id_pet: userIdPet || '',
            id_especie: '',
            nombre_raza: '',
            habilitada: true,
          }
    );
    setOpenModal(true);
  };

  // Cerrar Snackbar
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSnackbarMessage('');
  };

  // Guardar raza (crear o editar)
  const handleSave = async () => {
    try {
      if (!formData.nombre_raza || !formData.id_pet || !formData.id_especie) {
        const errorMsg = 'Nombre de la raza, veterinaria y especie son obligatorios';
        setError(errorMsg);
        setSnackbarMessage(errorMsg);
        setSnackbarOpen(true);
        return;
      }
      const payload = {
        id_pet: formData.id_pet,
        id_especie: formData.id_especie,
        nombre_raza: formData.nombre_raza,
        habilitada: formData.habilitada,
      };
      console.log('Guardando raza, payload:', payload);
      if (selectedRaza) {
        const response = await api.put(`/razas/${selectedRaza.id_raza}`, payload);
        console.log('Respuesta de PUT /razas:', response.data);
        const updatedRaza = normalizeRaza(response.data);
        if (updatedRaza) {
          const newRazas = razas.map(r => (r.id_raza === selectedRaza.id_raza ? updatedRaza : r));
          setRazas(newRazas);
          setOriginalRazas(newRazas);
          setSnackbarMessage('Raza actualizada exitosamente');
          setSnackbarOpen(true);
        }
      } else {
        const response = await api.post('/razas/', payload);
        console.log('Respuesta de POST /razas:', response.data);
        const newRaza = normalizeRaza(response.data);
        if (newRaza) {
          const newRazas = [...razas, newRaza];
          setRazas(newRazas);
          setOriginalRazas(newRazas);
          setSnackbarMessage('Raza creada exitosamente');
          setSnackbarOpen(true);
        }
      }
      setOpenModal(false);
      setError(null);
      setPage(0);
    } catch (error) {
      console.error('Error al guardar raza:', error);
      const errorMsg = 'Error al guardar raza: ' + (error.response?.data?.detail || error.message || JSON.stringify(error));
      setError(errorMsg);
      setSnackbarMessage(errorMsg);
      setSnackbarOpen(true);
    }
  };

  // Deshabilitar raza
    const handleToggleHabilitada = async (id, habilitada) => {
    try {
        const raza = razas.find(r => r.id_raza === id);
        if (!raza) {
            throw new Error('Raza no encontrada en el estado local');
        }
        
        // **IMPORTANTE**: Asegurar que 'habilitada' es booleano antes de invertirlo
        const estadoActual = !!habilitada; 
        const nuevoEstadoHabilitada = !estadoActual;
        
        const payload = {
            id_pet: raza.id_pet,
            id_especie: raza.id_especie,
            nombre_raza: raza.nombre_raza,
            habilitada: nuevoEstadoHabilitada,
        };
      
      console.log('Enviando PUT /razas/', id, 'con payload:', payload);
      const response = await api.put(`/razas/${id}`, payload);
      console.log('Respuesta de PUT /razas:', response.data);
      
      // Normaliza la raza usando SOLO la respuesta del servidor (response.data)
      const updatedRaza = normalizeRaza(response.data); // YA NO PASAS EL SEGUNDO ARGUMENTO
      
      if (updatedRaza) {
        const newRazas = razas.map(r => (r.id_raza === id ? updatedRaza : r));
        console.log('Nuevo estado de razas:', newRazas);
        setRazas(newRazas);
        setOriginalRazas(newRazas);
        setSnackbarMessage(`Raza ${updatedRaza.habilitada ? 'habilitada' : 'deshabilitada'} exitosamente`);
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error al actualizar estado:', error, 'Respuesta:', error.response);
      const errorMsg = 'Error al actualizar estado: ' + (error.response?.data?.detail || error.message || JSON.stringify(error));
      setError(errorMsg);
      setSnackbarMessage(errorMsg);
      setSnackbarOpen(true);
    }
  };

  // Eliminar raza
  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta raza?')) return;
    try {
      console.log('Enviando DELETE /razas/', id);
      const response = await api.delete(`/razas/${id}`);
      console.log('Respuesta de DELETE /razas:', response.data);
      const newRazas = razas.filter(r => r.id_raza !== id);
      setRazas(newRazas);
      setOriginalRazas(newRazas);
      setSnackbarMessage('Raza eliminada exitosamente');
      setSnackbarOpen(true);
      setPage(0);
    } catch (error) {
      console.error('Error al eliminar raza:', error);
      const errorMsg = 'Error al eliminar raza: ' + (error.response?.data?.detail || error.message || JSON.stringify(error));
      setError(errorMsg);
      setSnackbarMessage(errorMsg);
      setSnackbarOpen(true);
    }
  };

  // Manejo de paginación
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const paginatedRazas = razas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ p: 3 }}>
      <AppBar position="relative" sx={{ bgcolor: '#1e293b', mb: 3 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Gestión de Razas
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Buscar razas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            size="small"
            sx={{ bgcolor: 'white', borderRadius: 1 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Toolbar>
      </AppBar>
      <Container maxWidth={false} disableGutters>
        {loading || !userIdPet || !userIdRol ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" align="center">{error}</Typography>
        ) : razas.length === 0 ? (
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6">Sin datos</Typography>
            <Typography color="text.secondary">
              No se encontraron razas. Crea una nueva raza para comenzar.
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => handleOpenModal()}
              sx={{ mt: 2 }}
            >
              Nueva Raza
            </Button>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => handleOpenModal()}
                >
                  Nueva Raza
                </Button>
              </Box>
              <TableContainer
                component={Paper}
                sx={{
                  width: '100%',
                  overflowX: 'auto',
                  boxShadow: 3,
                }}
              >
                <Table
                  sx={{
                    tableLayout: 'auto',
                  }}
                  aria-label="tabla de razas"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        ID
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Nombre Raza
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Especie
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Veterinaria
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Habilitada
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Creado
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Actualizado
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold', textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                        Acciones
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedRazas.map((row) => {
                      if (!row || !row.id_raza) {
                        console.warn('Fila inválida en la tabla:', row);
                        return null;
                      }
                      return (
                        <TableRow
                          key={row.id_raza}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            {row.id_raza}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 }, fontWeight: 'bold' }}>
                            {row.nombre_raza}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            {especies.find(e => e.id_especie === row.id_especie)?.nombre_especie || 'N/A'}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            {pets.find(p => p.id_pet === row.id_pet)?.nombre_veterinaria || 'N/A'}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            <Switch
                                // SOLUCIÓN: Usar !! para convertir el valor numérico (1 o 0) a booleano (true o false)
                                checked={!!row.habilitada} 
                                // También corrige el segundo argumento para la función handleToggleHabilitada
                                // ya que espera un booleano para invertir el estado
                                onChange={() => handleToggleHabilitada(row.id_raza, !!row.habilitada)} 
                                color="primary"
                            />
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            {formatDate(row.createdAt)}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            {formatDate(row.updatedAt)}
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center', px: { xs: 1, sm: 2 } }}>
                            <IconButton
                              onClick={() => handleOpenModal(row)}
                              color="primary"
                            >
                              <EditIcon />
                            </IconButton>
                            {/* ===================== Eliminar===================== 
                            <IconButton
                              onClick={() => handleDelete(row.id_raza)}
                              color="error"
                            >
                              <DeleteIcon />
                            </IconButton>
                            */}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 2 }}>
                <Button
                  variant="contained"
                  disabled={page === 0}
                  onClick={() => handleChangePage(page - 1)}
                >
                  Anterior
                </Button>
                <Typography sx={{ alignSelf: 'center' }}>
                  Página {page + 1} de {Math.ceil(razas.length / rowsPerPage)}
                </Typography>
                <Button
                  variant="contained"
                  disabled={page >= Math.ceil(razas.length / rowsPerPage) - 1}
                  onClick={() => handleChangePage(page + 1)}
                >
                  Siguiente
                </Button>
              </Box>
            </Box>
          </Box>
        )}
        <Dialog open={openModal} onClose={() => setOpenModal(false)}>
          <DialogTitle>{selectedRaza ? 'Editar Raza' : 'Nueva Raza'}</DialogTitle>
          <DialogContent>
            <TextField
              label="Nombre de la Raza"
              fullWidth
              value={formData.nombre_raza}
              onChange={(e) => setFormData({ ...formData, nombre_raza: e.target.value })}
              sx={{ mt: 2 }}
              required
            />
            <TextField
              select
              label="Veterinaria"
              fullWidth
              value={formData.id_pet}
              onChange={(e) => setFormData({ ...formData, id_pet: e.target.value, id_especie: '' })}
              sx={{ mt: 2 }}
              required
            >
              {pets.length > 0 ? (
                pets.map((pet) => (
                  <MenuItem key={pet.id_pet} value={pet.id_pet}>
                    {pet.nombre_veterinaria}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  No hay veterinarias disponibles
                </MenuItem>
              )}
            </TextField>
            <TextField
              select
              label="Especie"
              fullWidth
              value={formData.id_especie}
              onChange={(e) => setFormData({ ...formData, id_especie: e.target.value })}
              sx={{ mt: 2 }}
              required
            >
              {especies.length > 0 && formData.id_pet ? (
                especies
                  .filter(especie => especie.id_pet === formData.id_pet)
                  .map((especie) => (
                    <MenuItem key={especie.id_especie} value={especie.id_especie}>
                      {especie.nombre_especie}
                    </MenuItem>
                  ))
              ) : (
                <MenuItem value="" disabled>
                  {formData.id_pet ? 'No hay especies disponibles para esta veterinaria' : 'Selecciona una veterinaria primero'}
                </MenuItem>
              )}
            </TextField>
            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
              <Switch
                checked={formData.habilitada}
                onChange={(e) => setFormData({ ...formData, habilitada: e.target.checked })}
                color="primary"
              />
              <Typography>Habilitada</Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
            <Button
              onClick={handleSave}
              variant="contained"
              disabled={!formData.nombre_raza || !formData.id_pet || !formData.id_especie}
            >
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ zIndex: 1500 }}
        >
          <Alert onClose={handleSnackbarClose} severity={error ? 'error' : 'success'} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default Razas;